import { Button } from "@alpacahq/ui/old";

import type { ClientStatus } from "~/v2/api/oauth";
import Switch from "~/v2/components/common/switch";
import type { SubmitAppMode } from "./SubmitApp.types";

export interface PublishFooterProps {
  mode: SubmitAppMode;
  status: ClientStatus;
  didAgree: boolean;
  onToggleStatus: () => void;
  onAgreementChange: (didAgree: boolean) => void;
  onCancel: () => void;
}

const AGREEMENT_URL =
  "https://s3.amazonaws.com/files.alpaca.markets/disclosures/Alpaca+OAuth+License+Agreement+(Online+Terms)+05-2022.docx.pdf";

export const PublishFooter = ({
  mode,
  status,
  didAgree,
  onToggleStatus,
  onAgreementChange,
  onCancel,
}: PublishFooterProps) => (
  <div className="flex flex-col gap-4">
    <section className="flex flex-col gap-2">
      <h2 className="m-0 text-2xl">Publish App</h2>
      <p className="m-0">
        Share you application with the rest of the community.
      </p>
      <label className="flex w-fit items-center gap-4">
        <span>Publish app</span>
        <Switch isChecked={status === "ACTIVE"} onChange={onToggleStatus} />
      </label>
    </section>

    <div className="text-left">
      <label className="inline-flex items-start gap-2 text-base">
        <input
          checked={didAgree}
          className="mt-1 h-4 w-4"
          onChange={(event) => onAgreementChange(event.target.checked)}
          type="checkbox"
        />
        <span>
          I agree to the{" "}
          <a
            className="underline"
            href={AGREEMENT_URL}
            rel="noopener noreferrer"
            target="_blank"
          >
            Terms and Conditions
          </a>
        </span>
      </label>
    </div>

    <div className="flex w-full max-w-xl justify-between gap-4 rounded-2xl p-4 shadow-2xl">
      <Button
        className="flex-1"
        onClick={onCancel}
        type="button"
        variant="alternate"
      >
        Cancel
      </Button>
      <Button
        {...{
          "amplitude-event-name":
            mode === "edit" ? "edit_connect_app" : "submit_connect_app",
        }}
        className="flex-1 disabled:opacity-25"
        disabled={!didAgree}
        type="submit"
      >
        Submit
      </Button>
    </div>
  </div>
);
